import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { ClockIcon } from "mds/icons";

export const ReadOnlyBreakoutDuration = ({
  value,
  className,
  variant = "default",
}: {
  value: number;
  className?: string;
  variant?: "default" | "compact";
}) => (
  <div
    className={twMerge(
      "flex min-h-8 items-center justify-between gap-4 text-sm font-medium text-black-tint-10",
      variant === "compact" && "flex-wrap justify-start gap-x-3 gap-y-2 pl-2",
      className,
    )}
  >
    <div
      className={twMerge(
        "flex items-center gap-2 whitespace-nowrap",
        variant === "compact" && "text-base font-medium leading-7 text-black-tint-20",
      )}
    >
      <ClockIcon />
      {t("breakout_group_modal.breakout_duration")}
    </div>
    <span
      className={twMerge(
        "whitespace-nowrap",
        variant === "compact" &&
          "rounded-md border border-black-tint-90 bg-black-tint-99 px-2 py-1 text-sm font-normal leading-5",
      )}
    >
      {value} {t("breakout_group_modal.min")}
    </span>
  </div>
);
